import { FLIPPER_KEYS } from '~/store/flippers/const'
import { FlipperResponseMap } from './types'

export enum ACCOUNT_STATEMENT_ACTIONS {
  SET_FLIPPERS = 'BLOCKCHAIN_ADDRESS_ACTIONS.SET_FLIPPERS',
}

export const FLIPPER_RESPONSE_MAP: Partial<FlipperResponseMap> = {
  [FLIPPER_KEYS.STRAITSX_XSGD_ACCOUNT_STATEMENT_UI]: 'isAccountStatementUIEnabled',
} as const
